// import React, { createContext, useEffect, useState } from 'react';
// import { SessionDetail } from '../Api/SessionDetail';
// // import io from 'socket.io-client';
// import { useLocation, useNavigate } from 'react-router-dom';//useBlocker,
// let socket = undefined;

// const Context = createContext();

// const ContextProvider = ({ children }) => {

//   const [userInfo, setUserInfo] = useState(null)
//   const [load, setLoad] = useState(false)
//   const [numberModal, setNumberModal] = useState(false)
//   const [depositModal, setDepositModal] = useState(false)
//   const [numberSelected, setNumberSelected] = useState("")
//   const [loadColor, setLoadColor] = useState("")
//   const [sessionDetail, setSessionDetail] = useState({})
//   const [setSessionDetailStatus] = useState(false)//sessionDetailStatus,
//   // const [socketConnected, setSocketConnected] = useState(false);
//   const [sideBarOpen, setSideBarOpen] = useState(false);
//   const [currentTimer] = useState({});//, setCurrentTimer
//   const [sessionResult, setSessionResult] = useState({});
//   const [withdrawDetailModal, setWithdrawDetailModal] = useState({});
//   const [withdrawDetailModalStatus, setWithdrawDetailModalStatus] = useState(false);
//   const [allBetModalStatus, setAllBetModalStatus] = useState(false);
//   const [allBetModalData, setAllBetModalData] = useState(null);
//   const [wallet, setWallet] = useState(0);
//   const auth_token = JSON.parse(localStorage.getItem('userinfo'))?.auth_token;

//   const { pathname } = useLocation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     async function getSession() {
//       if (auth_token) {
//         if (pathname === '/game') {
//           setLoad(true);
//           setLoadColor("#434343");
//         }
//         let data = {
//           username: JSON.parse(localStorage.getItem('userinfo'))?.username
//         }
//         let res = await SessionDetail(data)
//         console.log(res)
//         if (res) {
//           if (res.data.status) {
//             setLoad(false);
//             setSessionDetail(res.data);
//             setWallet(res.data.updated_wallet)
//             setSessionDetailStatus(true);
//           } else {
//             if (res.data.message === "token not belonging to the user") {
//               socket?.disconnect();
//               setLoad(false);
//               localStorage.removeItem('userinfo');
//               navigate('/');
//             }
//           }
//         }
//         setLoad(false);
//       }
//       else {
//         setSessionDetail({})
//       }
//     }
//     getSession();
//   }, [auth_token])

//   useEffect(() => {
//     const auth_token = JSON.parse(localStorage.getItem('userinfo'))?.auth_token;
//     if (!auth_token) {
//       navigate('/');
//     }

//     if (pathname !== '/game' && numberModal) {
//       setNumberModal(false);
//       navigate('/game');
//     }
//     if (pathname !== '/game' && sideBarOpen) {
//       setSideBarOpen(false);
//       navigate('/game');
//     }
//   }, [pathname, auth_token])

//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth' // or 'auto'
//     });
//   }, [pathname]);


//   return (
//     <Context.Provider
//       value={{
//         setSessionResult, setSessionDetail, setUserInfo, userInfo, setLoad, load, sessionDetail, setLoadColor, loadColor, setNumberModal, numberModal,
//         setNumberSelected, numberSelected, setDepositModal, depositModal, setSideBarOpen, sideBarOpen, currentTimer, socket, wallet,
//         setWallet, sessionResult, setWithdrawDetailModalStatus, setWithdrawDetailModal, withdrawDetailModalStatus, withdrawDetailModal,
//         allBetModalData, setAllBetModalData, allBetModalStatus, setAllBetModalStatus
//       }}
//     >
//       {children}
//     </Context.Provider>
//   );
// };

// export { Context, ContextProvider };




import React, { createContext, useEffect, useState } from 'react';
import { SessionDetail } from '../Api/SessionDetail';
import { useLocation, useNavigate } from 'react-router-dom';

let socket = undefined;
const Context = createContext();

const ContextProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [load, setLoad] = useState(false);
  const [numberModal, setNumberModal] = useState(false);
  const [depositModal, setDepositModal] = useState(false);
  const [numberSelected, setNumberSelected] = useState('');
  const [loadColor, setLoadColor] = useState('');
  const [sessionDetail, setSessionDetail] = useState({});
  // const [SessionDetailStatus, setSessionDetailStatus] = useState(false);
  const [sideBarOpen, setSideBarOpen] = useState(false);
  const [currentTimer] = useState({});
  const [sessionResult, setSessionResult] = useState({});
  const [withdrawDetailModal, setWithdrawDetailModal] = useState({});
  const [withdrawDetailModalStatus, setWithdrawDetailModalStatus] = useState(false);
  const [allBetModalStatus, setAllBetModalStatus] = useState(false);
  const [allBetModalData, setAllBetModalData] = useState(null);
  const [wallet, setWallet] = useState(0);
  const auth_token = JSON.parse(localStorage.getItem('userinfo'))?.auth_token;

  const { pathname } = useLocation();
  const navigate = useNavigate();

  // 🔧 Fix 1: Proper dependencies
  useEffect(() => {
    async function getSession() {
      if (auth_token) {
        if (pathname === '/game') {
          setLoad(true);
          setLoadColor("#434343");
        }
        let data = {
          username: JSON.parse(localStorage.getItem('userinfo'))?.username
        };
        let res = await SessionDetail(data);
        if (res) {
          if (res.data.status) {
            setLoad(false);
            setSessionDetail(res.data);
            setWallet(res.data.updated_wallet);
            // setSessionDetailStatus(true);
          } else if (res.data.message === "token not belonging to the user") {
            socket?.disconnect();
            setLoad(false);
            localStorage.removeItem('userinfo');
            navigate('/');
          }
        }
        setLoad(false);
      } else {
        setSessionDetail({});
      }
    }
    getSession();
  }, [auth_token, pathname, navigate]);

  // 🔧 Fix 2: Proper dependencies
  useEffect(() => {
    const auth_token = JSON.parse(localStorage.getItem('userinfo'))?.auth_token;
    if (!auth_token) {
      navigate('/');
    }

    if (pathname !== '/game' && numberModal) {
      setNumberModal(false);
      navigate('/game');
    }
    if (pathname !== '/game' && sideBarOpen) {
      setSideBarOpen(false);
      navigate('/game');
    }
  }, [pathname, navigate, numberModal, sideBarOpen]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return (
    <Context.Provider
      value={{
        setSessionResult, setSessionDetail, setUserInfo, userInfo, setLoad, load, sessionDetail,
        setLoadColor, loadColor, setNumberModal, numberModal, setNumberSelected, numberSelected,
        setDepositModal, depositModal, setSideBarOpen, sideBarOpen, currentTimer, socket, wallet,
        setWallet, sessionResult, setWithdrawDetailModalStatus, setWithdrawDetailModal, withdrawDetailModalStatus,
        withdrawDetailModal, allBetModalData, setAllBetModalData, allBetModalStatus, setAllBetModalStatus
      }}
    >
      {children}
    </Context.Provider>
  );
};

export { Context, ContextProvider };
